// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"70268eec","977":"5190b184"}[chunkId] + ".chunk.js";
};